import React, { ImgHTMLAttributes, useState } from "react";
import s from "./PhotoGalleryCard.less";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import clsx from "clsx";

const PhotoGalleryCard: React.FC<Partial<ImgHTMLAttributes<HTMLImageElement>>> =
  ({ onClick, src, alt }) => {
    const [imgLoad, setImgLoad] = useState(false);
    const ingLoadHandle = () => setImgLoad(true);

    return (
      <div className={s.photoWrapper} onClick={onClick}>
        {!imgLoad && (
          <SkeletonTheme color="#eaeaea" highlightColor="#d9d9d9">
            <Skeleton height={150} count={1} />
          </SkeletonTheme>
        )}
        <img
          className={clsx(s.photo, {
            [s.unloadImg]: !imgLoad,
          })}
          onLoad={ingLoadHandle}
          src={src}
          alt={alt}
        />
      </div>
    );
  };

export default PhotoGalleryCard;
